module.exports = __webpack_public_path__ + "assets/images/notfound-61c3c4c02d4c52ff8cb0e18d8c93f636.png";